
import React from 'react';

interface EntityIconProps {
  type: string;
}

export const EntityIcon: React.FC<EntityIconProps> = ({ type }) => {
  const iconMap = {
    client: '👤',
    order: '🛒',
    rental: '📅',
    inventory: '📦',
    task: '✓',
    store: '🏪'
  };
  
  return <span className="text-lg">{iconMap[type as keyof typeof iconMap] || '📄'}</span>;
};
